import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import useFormatLateFee from 'components/customer-details/content/fees/late_fees/useFormatLateFee'
import { ListItem } from '@mui/material'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import capitalize from 'lodash/capitalize'
import RenderLateFeeAmount from 'components/pricing/LateFees/common/RenderLateFeeAmount'

const LateFeePopoverItem = ({ lateFee }) => {
  const {
    formattedStartDate,
    formattedDuration,
    feeName,
    feeRate,
    isPricingPeriodOnce,
    amountCents,
    amountPercent,
    duration,
    pricingPeriod,
  } = useFormatLateFee(lateFee)
  const secondary = useMemo(() => {
    return [capitalize(pricingPeriod), formattedStartDate, !isPricingPeriodOnce && formattedDuration].filter(Boolean).join(' | ')
  }, [pricingPeriod, duration])

  const capitalizedFeeName = useMemo(() => capitalize(feeName), [feeName])

  return (
    <ListItem>
      <ListItemText
        primary={capitalizedFeeName}
        secondary={secondary}
        slotProps={{
          primary: {
            variant: 'body1',
            fontWeight: '500',
            color: 'textPrimary',
          },

          secondary: {
            variant: 'body2',
            color: 'textSecondary',
          },
        }}
      />
      <Typography variant="h5">
        <RenderLateFeeAmount feeRate={feeRate} amountCents={amountCents} amountPercent={amountPercent} />
      </Typography>
    </ListItem>
  )
}

LateFeePopoverItem.propTypes = {
  lateFee: PropTypes.object,
}

export default LateFeePopoverItem
